class TextComponent extends HTMLElement {
  shimmer() {
    this.setAttribute('shimmer', '')
  }
}

if (!customElements.get('ui-text-component')) {
  customElements.define('ui-text-component', TextComponent)
}

export function resetShimmer(container = document.body) {
  const shimmer = container.querySelectorAll('[shimmer]')
  shimmer.forEach((item) => {
    item.removeAttribute('shimmer')
  })
}
